import { TFunction } from 'i18next';
import { POOL_STATUS } from 'src/DTO/PoolStatus.enum';
import { DELLA_COUNTIES } from 'src/utils/constants.util';

const BOOLEAN_OPTIONS = ['true', 'false'];
const POOL_STATUS_OPTIONS = Object.values(POOL_STATUS);

export const getIsSelectInput = (columnId: string) => {
  return (
    columnId === 'preferredLocations' || columnId === 'interviewId' || columnId === 'poolStatus'
  );
};

export const getInputLabel = (columnId: string, t: TFunction) => {
  switch (columnId) {
    case 'name':
      return t('workersScreen.worker');
    case 'phoneNumber':
      return t('workersScreen.phone');
    case 'preferredLocations':
      return t('workersScreen.preferredLocations');
    case 'interviewId':
      return t('workersScreen.interview.label');
    case 'poolStatus':
      return t('workersScreen.status');
    default:
      return '';
  }
};

const getPoolStatusLabel = (value: string, t: TFunction) => {
  switch (value) {
    case POOL_STATUS.ACTIVE:
      return t('workerCard.active');
    case POOL_STATUS.INACTIVE:
      return t('workerCard.inActive');
    case POOL_STATUS.NEW_APPLICATION:
      return t('workerCard.newApplicant');
    case POOL_STATUS.PENDING_OFFER:
      return t('workerCard.jobOfferSent');
    case POOL_STATUS.WORKER_UNDER_REVIW:
      return t('workerCard.documentReview');
    default:
      return '';
  }
};

const getInterviewStatusLabel = (value: string, t: TFunction) => {
  if (value === 'true') return t('workersScreen.interview.options.true');
  if (value === 'false') return t('workersScreen.interview.options.false');
  return '';
};

export const getOptionsByColumnId = (columnId: string, t: TFunction) => {
  switch (columnId) {
    case 'preferredLocations':
      return { options: DELLA_COUNTIES, getLabel: (val: string) => val };
    case 'poolStatus':
      return {
        options: POOL_STATUS_OPTIONS,
        getLabel: (val: string) => getPoolStatusLabel(val, t),
      };
    case 'interviewId':
      return {
        options: BOOLEAN_OPTIONS,
        getLabel: (val: string) => getInterviewStatusLabel(val, t),
      };
    default:
      return { options: [], getLabel: (val: string) => val };
  }
};
